import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';   // Import Swiper React components
import 'swiper/css';                // Import Swiper CSS
import 'swiper/css/autoplay';        // Import Autoplay CSS
import { Autoplay } from 'swiper/modules';  // Correct import for Autoplay module in Swiper 8+

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function PenggunaLayanan() {
    useEffect(() => {
        // Inisialisasi animasi jika diperlukan
    }, []);


    const [icons, setIcons] = useState([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/client-logos`)
            .then(res => res.json())
            .then(data => setIcons(data.data));
    }, []);


    return (
        <div className="relative py-32 bg-gray-900 text-white">
            <div className="container mx-auto px-4 lg:px-8">
                <h1 className="text-3xl font-bold text-blue-400 text-center mb-8">Pengguna Layanan</h1>

                {/* Swiper Carousel */}
                <Swiper
                    spaceBetween={30}          // Jarak antar slide
                    slidesPerView={5}          // Berapa banyak slide yang ditampilkan
                    loop={true}                // Infinite loop
                    autoplay={{
                        delay: 0,              // Tidak ada jeda
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,  // Pause ketika mouse berada di atas slider
                    }}
                    speed={3000}               // Kecepatan transisi
                    modules={[Autoplay]}       // Daftarkan modul Autoplay di sini
                >
                    {icons.map((icon) => (
                        <SwiperSlide key={icon.id}>
                            <LazyLoadImage
                                src={icon.src}
                                alt={icon.alt}
                                className="w-32 h-auto object-contain mx-auto"
                                effect="blur"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Contact Section */}
                <div className="text-center p-10">
                    <p className="text-xl font-semibold">Apakah Anda ingin logo perusahaan Anda tampil di sini?</p>
                    <p className='text-md'>Hubungi kami di{" "} </p>
                    <a href="mailto:marketing@len-telko.co.id" className="text-yellow-500 hover:underline">
                        marketing@len-telko.co.id
                    </a>
                </div>
            </div>
        </div>
    );
}

export default PenggunaLayanan;
